export const ADD_USER_CONTEXT_TO_SENTRY = 'ADD_USER_CONTEXT_TO_SENTRY';

export const SOCKET_CONNECT = 'SOCKET_CONNECT';
export const SOCKET_CONNECT_SUCCESS = 'SOCKET_CONNECT_SUCCESS';
export const SOCKET_CONNECT_FAIL = 'SOCKET_CONNECT_FAIL';

export const SOCKET_CONNECTING = 'SOCKET_CONNECTING';
export const SOCKET_RECONNECT = 'SOCKET_RECONNECT';
export const SOCKET_CONNECTED = 'SOCKET_CONNECTED';
export const SOCKET_DISCONNECTED = 'SOCKET_DISCONNECTED';

export const SYNC_DATA = 'SYNC_DATA';

export const GET_APP_START_DATA = 'GET_APP_START_DATA';
export const GET_APP_START_DATA_SUCCESS = 'GET_APP_START_DATA_SUCCESS';

export const MAXIMUM_SOCKET_RECONNECT_ATTEMPTS_REACHED = 'MAXIMUM_SOCKET_RECONNECT_ATTEMPTS_REACHED';

// General Application Actions
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';

export const GET_MESSAGES = 'GET_MESSAGES';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const GET_MESSAGES_PAGING_DATA = 'GET_MESSAGES_PAGING_DATA';

export const GET_ALL_MESSAGES = 'GET_ALL_MESSAGES';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_MESSAGE_SUCCESS = 'ADD_MESSAGE_SUCCESS';

// A local message is a message that is added to redux before being sent to the backend.
// We do this so we can show it to the sending user immediately and update it accordingly if it fails.
export const ADD_LOCAL_MESSAGE = 'ADD_LOCAL_MESSAGE';
export const ADD_LOCAL_ATTACHMENT = 'ADD_LOCAL_ATTACHMENT';
export const UPDATE_LOCAL_MESSAGE = 'UPDATE_LOCAL_MESSAGE';
export const UPDATE_LOCAL_ATTACHMENT = 'UPDATE_LOCAL_ATTACHMENT';
export const REMOVE_MESSAGES = 'REMOVE_MESSAGES';
export const REMOVE_ATTACHMENTS = 'REMOVE_ATTACHMENTS';

export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const SELECT_MESSAGE = 'SELECT_MESSAGE';
export const DESELECT_MESSAGES = 'DESELECT_MESSAGES';

export const ADD_MESSAGE_FAIL = 'ADD_MESSAGE_FAIL';
export const RETRY_MESSAGE_FAIL = 'RETRY_MESSAGE_FAIL';
export const DELETE_MESSAGE_FAIL = 'DELETE_MESSAGE_FAIL';

// Outgoing get attachment action
export const GET_ATTACHMENT = 'GET_ATTACHMENT';
// Api response handler receives response and if successful, appends _SUCCESS and passes to reducer
export const GET_ATTACHMENT_SUCCESS = 'GET_ATTACHMENT_SUCCESS';
export const REVOKE_ATTACHMENT_URL = 'REVOKE_ATTACHMENT_URL';

export const REMOVE_VIDEO = 'REMOVE_VIDEO';
export const ADD_VIDEO = 'ADD_VIDEO';

// HTTP version of get_attachment
export const DOWNLOAD_ATTACHMENT = 'DOWNLOAD_ATTACHMENT';
export const DOWNLOAD_ATTACHMENT_SUCCESS = 'DOWNLOAD_ATTACHMENT_SUCCESS';
export const DOWNLOAD_ATTACHMENT_FAIL = 'DOWNLOAD_ATTACHMENT_FAIL';

// Actions for downloading video preview images for inline display
export const DOWNLOAD_VIDEO_IMAGE_ATTACHMENT = 'DOWNLOAD_VIDEO_IMAGE_ATTACHMENT';
export const DOWNLOAD_VIDEO_IMAGE_ATTACHMENT_SUCCESS = 'DOWNLOAD_VIDEO_IMAGE_ATTACHMENT_SUCCESS';

export const MESSAGE_RECEIVED = 'MESSAGE_RECEIVED';
export const MESSAGE_RECEIVED_SUCCESS = 'MESSAGE_RECEIVED_SUCCESS';
export const API_RESPONSE_RECEIVED = 'API_RESPONSE_RECEIVED';

export const TYPING_RECEIVED = 'TYPING_RECEIVED';
export const TYPING_COMPLETE = 'TYPING_COMPLETE';

export const SET_TYPING = 'SET_TYPING';

export const SET_CHATS = 'SET_CHATS';
export const GET_CHATS = 'GET_CHATS';
export const GET_CHATS_SUCCESS = 'GET_CHATS_SUCCESS';
export const GET_CHATS_FAIL = 'GET_CHATS_FAIL';
export const GET_CHATS_TIMEOUT = 'GET_CHATS_TIMEOUT';

export const GET_ALL_CHATS = 'GET_ALL_CHATS';
export const GET_ALL_CHATS_SUCCESS = 'GET_ALL_CHATS_SUCCESS';

export const GET_PUBLIC_CHANNELS = 'GET_PUBLIC_CHANNELS';
export const GET_PUBLIC_CHANNELS_SUCCESS = 'GET_PUBLIC_CHANNELS_SUCCESS';
export const GET_PUBLIC_CHANNELS_FAIL = 'GET_PUBLIC_CHANNELS_FAIL';
export const GET_PUBLIC_CHANNELS_TIMEOUT = 'GET_PUBLIC_CHANNELS_TIMEOUT';

export const START_DM = 'START_DM';

// Visually hide the chat from the sidebar
export const HIDE_CHAT = 'HIDE_CHAT';
export const HIDE_CHAT_SUCCESS = 'HIDE_CHAT_SUCCESS';

// Add the chat to the sidebar
export const SHOW_CHAT = 'SHOW_CHAT';
export const SHOW_CHAT_SUCCESS = 'SHOW_CHAT_SUCCESS';

export const GET_UNREAD_COUNT = 'GET_UNREAD_COUNT';
export const GET_UNREAD_COUNT_SUCCESS = 'GET_UNREAD_COUNT_SUCCESS';

// Unread count types (non api calls)
export const INCREMENT_UNREAD_COUNT = 'INCREMENT_UNREAD_COUNT';
export const CLEAR_UNREAD_COUNT = 'CLEAR_UNREAD_COUNT';

export const SEARCH_USERS = 'SEARCH_USERS';
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';
export const SEARCH_USERS_FAIL = 'SEARCH_USERS_FAIL';
export const SEARCH_USERS_TIMEOUT = 'SEARCH_USERS_TIMEOUT';

export const GET_USERS = 'GET_USERS';

export const APP_START = 'APP_START';

export const GET_IDENTITY = 'GET_IDENTITY';
export const GET_IDENTITY_SUCCESS = 'GET_IDENTITY_SUCCESS';
export const IDENTITY_IS_WEBAPP_USER = 'IDENTITY_IS_WEBAPP_USER';

export const SET_AUTH = 'SET_AUTH';
export const REMOVE_AUTH = 'REMOVE_AUTH';

export const START_CHANNEL = 'START_CHANNEL';

export const ADD_USERS_TO_CHANNEL = 'ADD_USERS_TO_CHANNEL';
export const ADD_USERS_TO_CHANNEL_SUCCESS = 'ADD_USERS_TO_CHANNEL_SUCCESS';

export const JOIN_CHANNEL = 'JOIN_CHANNEL';
export const JOIN_CHANNEL_SUCCESS = 'JOIN_CHANNEL_SUCCESS';

export const LEAVE_CHANNEL = 'LEAVE_CHANNEL';
export const LEAVE_CHANNEL_SUCCESS = 'LEAVE_CHANNEL_SUCCESS';

export const MARK_AS_READ = 'MARK_AS_READ';
export const MARK_AS_READ_SUCCESS = 'MARK_AS_READ_SUCCESS';

export const SAVE_SCROLL_POSITION = 'SAVE_SCROLL_POSITION';

export const SAVE_MESSAGE_INPUT_DATA = 'SAVE_MESSAGE_INPUT_DATA';

export const USER_INVITED_TO_CHANNEL = 'USER_INVITED_TO_CHANNEL';
export const USER_ADDED_TO_CHANNEL = 'USER_ADDED_TO_CHANNEL';
export const USER_LEFT_CHANNEL = 'USER_LEFT_CHANNEL';

// Modal types
export const MODAL_REGISTER = 'MODAL_REGISTER';
export const MODAL_UPDATE = 'MODAL_UPDATE';
export const MODAL_CLOSE = 'MODAL_CLOSE';

// PDF type(s)
export const PDF_EXPORT_MESSAGES = 'PDF_EXPORT_MESSAGES';
export const PDF_BUILD_FINISH = 'PDF_BUILD_FINISH';
export const PDF_BUILD_START = 'PDF_BUILD_START';
export const PDF_SEND_TO_INBOX = 'PDF_SEND_TO_INBOX';
export const PDF_SEND_TO_INBOX_SUCCESS = 'PDF_SEND_TO_INBOX_SUCCESS';
export const PDF_SEND_TO_INBOX_FAIL = 'PDF_SEND_TO_INBOX_FAIL';
export const PDF_SEND_TO_INBOX_TIMEOUT = 'PDF_SEND_TO_INBOX_TIMEOUT';
export const PDF_SEND_TO_INBOX_CONFIRM = 'PDF_SEND_TO_INBOX_CONFIRM';
export const PDF_CLEAR_STATUS = 'PDF_CLEAR_STATUS';

// Event types
export const USER_MENTIONED = 'USER_MENTIONED';
export const USER_CREATED = 'USER_CREATED';
export const USER_UPDATED = 'USER_UPDATED';
export const USER_STATUS_CHANGED = 'USER_STATUS_CHANGED';
export const START_PUBLIC_CHANNEL = 'START_PUBLIC_CHANNEL';
export const SEND_TO_INBOX_RESULT = 'SEND_TO_INBOX_RESULT';

export const ADD_ERROR = 'ADD_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const LOGOUT = 'LOGOUT';

// **** Constants used exclusively for webapp smart chat users **
export const FORCE_LOGOUT = 'FORCE_LOGOUT';
export const WEBSOCKET_PING = 'WEBSOCKET_PING';
// **************************************************************
